export const objToArray = data => {
    return data ? Object.keys(data).map(key => data[key]) : []
}

export const objToArrayWithId = data => {
    return data ? Object.keys(data).map((key) => {
        return { id: key, ...data[key] }
    }) : []
}